import { RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import {routes} from "./app.routes";


@NgModule({
    imports: [
        RouterModule.forRoot(routes, { scrollPositionRestoration: 'enabled', anchorScrolling: 'enabled', onSameUrlNavigation: 'reload' })
    ],
    exports: [
        RouterModule
    ]
})
export class AppRoutingModule {
}


